import { twJoin } from 'tailwind-merge'
import { Markdown } from '@/components/shared/text/Markdown'
import { Pill } from '@/components/shared/text/Pill'
import { tagsTableLeadingClass, tagsTableRowClass } from '../tagsTableLayout'
import type { CompositTableRow } from './types'

// Use by `app/scripts/StaticDatasets/geojson/region-bb/bb-trassenscout-beteiligung/meta.ts`
export const tableKeyTrassencoutSurveyResponse = 'composit_trassenscout_survey_response'
export const TagsTableRowCompositTrassencoutSurveyResponse = ({ properties }: CompositTableRow) => {
  const color =
    properties.precision === 'point'
      ? '#7c3aed' // violet-600
      : '#c026d3' // fuscia-600
  const dimColor = properties.precision === 'point' ? '#ede9fe' : '#fae8ff'

  return (
    <tr className={tagsTableRowClass}>
      <td
        className={twJoin(
          'space-y-3 border-l-2 py-2 pr-2 pl-2 text-sm',
          tagsTableLeadingClass,
          'font-medium text-gray-900',
        )}
        colSpan={2}
        style={{ borderColor: color }}
      >
        <div style={{ backgroundColor: dimColor }} className="-mt-2 -mr-2 -ml-2 px-2 py-2.5">
          {properties.precision === 'point'
            ? 'Dieser Hinweis ist an einer konkreten Stelle verortet'
            : 'Dieser Hinweis bezieht sich auf die gesamte Verbindung'}
        </div>
        <p>
          Verbindungs-Nummer: {properties.lineId}
          <br />
          Hinweis-Nummer: {properties.reponseId}
        </p>
        <p>
          <strong>{properties.Institut}</strong>, {properties.Landkreis || '–'}
          <br />
          <strong>{properties.Author}</strong> schrieb am{' '}
          {new Date(properties.sessionCreatedAt).toLocaleDateString()}
        </p>
        <p>
          <Pill color="gray">{properties.category}</Pill>
        </p>
        <hr />
        <Markdown markdown={properties.text} />

        {properties.answer ? (
          <div className="-mt-2 -mr-2 -ml-2 bg-gray-800 px-2 py-2.5">
            <Markdown className="prose-invert" markdown={properties.answer} />
          </div>
        ) : null}
      </td>
    </tr>
  )
}
